export const TIME_ONE_MINUTE = 60 * 1000
export const TIME_ONE_HOUR = 60 * 60 * 1000
export const TIME_ONE_DAY = 24 * 60 * 60 * 1000

export const TIME_FIVE_MINUTES = 5 * 60 * 1000
